export const colorSet = [
  {
    title: "White",
    colors: [
      "#000000", // primary
      "#ededed", // secondary
      "#ffffff", // background
      "#000000", // primaryFont
      "#000000", // visual
      "#4a4a4a", // secondaryFont
    ],
  },
  {
    title: "Dark",
    colors: [
      "#ffffff", // primary
      "#262626", // secondary
      "#000000", // background
      "#ffffff", // primaryFont
      "#515151", // visual
      "#a6a6a6", // secondaryFont
    ],
  },
];

export const fonts = [
  {
    name: "Primary",
    value: "Public Sans",
    provider: "google",
  },
];
